




















































































































































































































import { Vue, Component } from 'vue-property-decorator';
import axios from 'axios';
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";

enum ProductEnum {
  OfisPro = 1,
  IcraProWeb = 2,
  EicraPro = 3,
  ImzaciGirisi = 4
}

@Component({
  components: {EnabledSwitch}
})
export default class DuyuruListesi extends Vue {
  ProductEnum = ProductEnum;



  getProductChipColor(name: string) {
    if (name === 'İcraProWeb') {
      return { color: '#90CAF9', textColor: 'white' };
    }
    if (name === 'EicraPro') {
      return { color: '#FFB74D', textColor: 'white' };
    }
    if (name === 'OfisPro') {
      return { color: '#757575', textColor: 'white' };
    }
    if (name === 'İmzacı Girişi') {
      return { color: '#E57373', textColor: 'white' };
    }
    return { color: 'grey lighten-3', textColor: 'grey darken-3' };
  }

  duyurular: any[] = [];
  loading = false;
  dialog = false;
  menu = false;
  editingId: number | null = null;

  form = {
    duyuru_type: [] as string[],
    product: [] as { text: string; value: number }[],
    duyuru_baslik: '',
    duyuru_metin: '',
    aktif: false,
    duyuru_tarih: '',
    versiyon: ''
  };

  headers = [
    { text: 'ID', value: 'duyuru_id' },
    { text: 'Başlık', value: 'duyuru_baslik' },
    { text: 'Tip', value: 'duyuru_type' },
    { text: 'Ürün', value: 'product' },
    { text: 'Tarih', value: 'duyuru_tarih' },
    { text: 'Versiyon', value: 'versiyon' },
    { text: 'Durum', value: 'aktif' },
    { text: 'İşlemler', value: 'actions', sortable: false }
  ];

  mounted() {
    this.getDuyurular();
  }

  async getDuyurular() {
    this.loading = true;
    try {
      let response = await this.$http.get( "duyurular");
      this.duyurular = (response.data || []).map((d: any) => ({
        ...d,
        aktif: typeof d.aktif === 'string' ? Number(d.aktif) : d.aktif
      }));
    } catch (e) {
      console.error('Duyurular alınamadı', e);
    } finally {
      this.loading = false;
    }
  }

  getProductName(id: number): string {
    switch (id) {
      case ProductEnum.OfisPro: return 'OfisPro';
      case ProductEnum.IcraProWeb: return 'İcraProWeb';
      case ProductEnum.EicraPro: return 'EicraPro';
      case ProductEnum.ImzaciGirisi: return 'İmzacı Girişi';
      default: return 'Bilinmiyor';
    }
  }

  async saveDuyuru() {
    try {
      const selectedProducts = (this.form.product || []).map((p) => {
        return {
          id: {
            text: p.text,
            value: p.value
          }
        };
      });

      const selectedTypes = (this.form.duyuru_type || []).map((type: any) => {
        return {
          id: {
            text: type,
            value: type
          }
        };
      });

      if (this.editingId !== null) {
        await this.$http.post(`/duyurular/${this.editingId}`, {
          duyuru_type: JSON.stringify(selectedTypes),
          product: JSON.stringify(selectedProducts),
          duyuru_baslik: this.form.duyuru_baslik,
          duyuru_metin: this.form.duyuru_metin,
          aktif: this.form.aktif ? 1 : 0,
          duyuru_tarih: this.form.duyuru_tarih,
          versiyon: this.form.versiyon
        });
      } else {
        await this.$http.post('/duyurular', {
          duyuru_type: JSON.stringify(selectedTypes),
          product: JSON.stringify(selectedProducts),
          duyuru_baslik: this.form.duyuru_baslik,
          duyuru_metin: this.form.duyuru_metin,
          aktif: this.form.aktif ? 1 : 0,
          duyuru_tarih: this.form.duyuru_tarih,
          versiyon: this.form.versiyon
        });
      }

      this.dialog = false;
      this.editingId = null;
      this.resetForm();
      this.getDuyurular();
    } catch (e) {
      console.error('Duyuru kaydedilemedi', e);
    }
  }

  resetForm() {
    this.form = {
      duyuru_type: [] as string[],
      product: [] as { text: string; value: number }[],
      duyuru_baslik: '',
      duyuru_metin: '',
      aktif: false,
      duyuru_tarih: '',
      versiyon: ''
    };
  }

  openNewDuyuru() {
    this.resetForm();
    this.editingId = null;
    this.dialog = true;
  }
  // Delete duyuru by id
  async deleteDuyuru(id: number) {
    try {
      await this.$http.delete(`/duyurular/${id}`);
      this.getDuyurular();
    } catch (e) {
      console.error('Duyuru silinemedi', e);
    }
  }

  safeParseProducts(productData: any) {
    try {
      if (typeof productData === 'string') {
        const parsed = JSON.parse(productData);
        if (Array.isArray(parsed)) return parsed;
      } else if (Array.isArray(productData)) {
        return productData;
      }
    } catch (e) {
      console.error('Product JSON parse error:', e);
    }
    return [];
  }

  async updateDuyuru(item: any) {
    try {
      const parsedTypes = this.safeParseProducts(item.duyuru_type);
      this.form.duyuru_type = parsedTypes.map((t: any) => {
        if (t.id && typeof t.id === 'object' && 'text' in t.id && 'value' in t.id) {
          return t.id.text;
        } else if (t.id && typeof t.id === 'string') {
          return t.id;
        } else if (typeof t === 'string') {
          return t;
        }
        return null;
      }).filter((v: any) => v !== null);

      const parsedProducts = this.safeParseProducts(item.product);
      const mappedProducts = parsedProducts.map((p: any) => {
        if (p.id && typeof p.id === 'object' && 'value' in p.id && 'text' in p.id) {
          return { text: p.id.text, value: p.id.value };
        } else if (p.id && typeof p.id === 'number') {
          const productName = this.getProductName(p.id);
          return { text: productName, value: p.id };
        }
        return null;
      }).filter((v): v is { text: string; value: number } => v !== null);

      this.form.product = mappedProducts;

      this.form.duyuru_baslik = item.duyuru_baslik;
      this.form.duyuru_metin = item.duyuru_metin;
      this.form.aktif = item.aktif === 1 || item.aktif === '1' || item.aktif === true || item.aktif === 'true';
      this.$nextTick(() => {
        this.$forceUpdate(); // ensure v-switch reacts to the change
      });
      this.form.duyuru_tarih = item.duyuru_tarih ? item.duyuru_tarih.slice(0, 10) : '';
      this.form.versiyon = item.versiyon || '';

      this.dialog = true;
      this.editingId = item.duyuru_id;
    } catch (e) {
      console.error('Duyuru yüklenemedi:', e);
    }
  }
}
